/**
 * Render a numeric amount as EUR currency (e.g. 78 → "€ 78,00").
 * Locale is left to the browser; the currency is fixed to EUR (there is no
 * currency field in the data — Rituals is a European retailer).
 */
export function formatPrice(value: number): string {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "EUR",
  }).format(value);
}
